module.exports = __webpack_public_path__ + "static/media/car-marker.c37c7a43.png";